import dayjs from 'dayjs';

const formatDate = 'DD-MM-YYYY';

/**
 * Даты для календарей в разделах статистики, лидов
 *
 * @returns {Array}
 */
export const getCommonDateOptions = () => [
  {
    date: [
      dayjs().subtract(30, 'day').format(formatDate),
      dayjs().format(formatDate),
    ],
    label: 'Последние 30 дней',
  },
  {
    date: [
      dayjs().subtract(7, 'day').format(formatDate),
      dayjs().format(formatDate),
    ],
    label: 'Последние 7 дней',
  },
  {
    date: [
      dayjs().subtract(1, 'month').startOf('month').format(formatDate),
      dayjs().subtract(1, 'month').endOf('month').format(formatDate),
    ],
    label: 'Прошлый месяц',
  },
  {
    date: [
      dayjs().startOf('month').format(formatDate),
      dayjs().format(formatDate),
    ],
    label: 'Этот месяц',
  },
  {
    date: [
      dayjs().subtract(1, 'week').startOf('week').format(formatDate),
      dayjs().subtract(1, 'week').endOf('week').format(formatDate),
    ],
    label: 'Последняя неделя',
  },
  {
    date: [
      dayjs().startOf('week').format(formatDate),
      dayjs().format(formatDate),
    ],
    label: 'Эта неделя',
  },
];

/**
 * Даты для календаря скачивания PDF отчета
 *
 * @returns {Array}
 */
export const getReportDateOptions = () => [
  {
    date: [
      dayjs().subtract(1, 'month').startOf('month').format(formatDate),
      dayjs().subtract(1, 'month').endOf('month').format(formatDate),
    ],
    label: 'Прошлый месяц',
  },
  {
    date: [
      dayjs().subtract(7, 'day').format(formatDate),
      dayjs().format(formatDate),
    ],
    label: 'Последние 7 дней',
  },
  {
    date: [
      dayjs().subtract(30, 'day').format(formatDate),
      dayjs().format(formatDate),
    ],
    label: 'Последние 30 дней',
  },
  {
    date: [
      dayjs().subtract(365, 'day').format(formatDate),
      dayjs().format(formatDate),
    ],
    label: 'Последний год',
  },
];
